import { ToastContext } from "@/context";
import { useContext } from "react";

const useToast = () => {
  const { showToast } = useContext(ToastContext);
  console.log("showToast", showToast);

  return { showToast };
};

export default useToast;
